import { Redirect, Router } from "@reach/router";
import useAuth from "hooks/useAuth";
import SideNav from "../../components/SideNav/SideNav";
import dashboardRoute from "../../config/dashboardRoute";
import styles from "./layout.module.css";

export default function Suppliers(props: ReachPathProps) {
  const { user } = useAuth();

  if (!user) return <Redirect from="*" to="/login" noThrow />;
  return (
    <div className={styles.layout}>
      <SideNav />
      <main className={styles.main__container}>
        <Router>
          {dashboardRoute.map((route) => (
            <route.component path={route.path} key={route.path} />
          ))}
        </Router>
      </main>
    </div>
  );
}
